module.exports = __webpack_public_path__ + "static/access_handbook_new_722x705-49c30ffc97f71a3b6319f4dc59e5f624.png";